var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report__container"},[_c('div',{staticClass:"report__filter"},[_c('div',{staticClass:"filter-header"},[_vm._v("FILTERS")]),_vm._t("filter")],2),_c('div',{staticClass:"report__content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }